import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '@/auth/AuthContext'
import { LoadingState } from './ui'

/** TEMP: skip role predicates until RBAC is restored. */
const TEMP_ALLOW_ALL = true

export function RoleGate({
  predicate,
  enforce = false,
}: {
  predicate: (roles: string[]) => boolean
  /** When set, the predicate applies even while the temporary open-access flag is on. */
  enforce?: boolean
}) {
  const { user, isAuthenticated, bootstrapping } = useAuth()

  if (bootstrapping) return <LoadingState label="Restoring session…" />
  if (!isAuthenticated || !user) {
    return <Navigate to="/login" replace />
  }
  if ((enforce || !TEMP_ALLOW_ALL) && !predicate(user.roles ?? [])) {
    return <Navigate to="/access-denied" replace />
  }
  return <Outlet />
}
